/**
 * Where a template validation message points, when it names a spot. The
 * extractor's messages come in three locatable shapes:
 *   • a per-tag parse error embeds the literal tag — `could not parse '{{ … }}': …`
 *   • an unpaired block leads with the tag body — `if client.name: block_start
 *     has no matching block_end (…)` — search for `{% <body>`
 *   • a binding error leads with the field path — `legal_entity_company.vat_id: …`
 * Generic syntax errors (a line number, no tag) are not locatable.
 *
 * Shared by the Word add-in (which selects the text in Word) and the Fields
 * page (which selects the chip in the document preview).
 */
export interface ValidationIssueTarget {
  /** 'text' → find the literal tag text; 'field' → find the field by path. */
  mode: 'text' | 'field';
  query: string;
}

export function locatableIssueTarget(messageText: string): ValidationIssueTarget | null {
  const parseMatch = messageText.match(/could not parse (['"])([\s\S]*?)\1:/);
  if (parseMatch) return { mode: 'text', query: parseMatch[2] };
  const blockMatch = messageText.match(/^(.+?): block_(?:start|end|middle) has no matching block_/);
  if (blockMatch) return { mode: 'text', query: `{% ${blockMatch[1]}` };
  const fieldMatch = messageText.match(/^([\w.[\]]+):\s/);
  if (fieldMatch) return { mode: 'field', query: fieldMatch[1] };
  return null;
}
